export const siteStats = [
  { id: "stat-1", label: "覆盖终端", value: "3", unit: "类", note: "网页 / 手机浏览器 / APP" },
  { id: "stat-2", label: "常用线路", value: "多", unit: "条", note: "按速度与稳定性分级" },
  { id: "stat-3", label: "内容类型", value: "5", unit: "类", note: "电影、剧集、综艺等" },
  { id: "stat-4", label: "整理更新", value: "持续", unit: "", note: "地址变动时同步维护" },
];

export const quickEntries = [
  {
    id: "entry-official",
    icon: "ri-global-line",
    title: "官网入口",
    desc: "先确认主入口是否可正常打开，再决定后续使用哪种方式观看，避免在陌生页面里来回跳转。",
    action: "查看线路状态",
    href: "#lines",
  },
  {
    id: "entry-address",
    icon: "ri-link-m",
    title: "最新地址",
    desc: "主地址失效时按线路分组逐个尝试，本页会按稳定性标注，方便你快速换到可用的一条。",
    action: "对比线路",
    href: "#lines",
  },
  {
    id: "entry-app",
    icon: "ri-smartphone-line",
    title: "APP 下载说明",
    desc: "了解安卓与 iOS 两端的安装方式、占用空间和常用功能差异，再决定是否安装客户端。",
    action: "查看多端对比",
    href: "#devices",
  },
  {
    id: "entry-guide",
    icon: "ri-book-open-line",
    title: "使用指南",
    desc: "收录打不开、加载慢、清晰度切换等常见问题的排查顺序，新手按步骤走一遍基本能解决。",
    action: "阅读常见问题",
    href: "#faq",
  },
];

export const lineGroups = [
  {
    id: "line-web",
    tabLabel: "网页端线路",
    intro: "直接在浏览器打开，无需安装任何程序，适合电脑端长时间观看。",
    lines: [
      { id: "web-1", name: "网页主入口", region: "通用", status: "可用", statusKey: "ok", speed: "较快", note: "日常首选，加载完整页面资源" },
      { id: "web-2", name: "网页备用入口", region: "通用", status: "可用", statusKey: "ok", speed: "中等", note: "主入口拥堵时切换使用" },
      { id: "web-3", name: "网页精简入口", region: "通用", status: "可用", statusKey: "ok", speed: "最快", note: "只加载核心内容，弱网更稳" },
    ],
  },
  {
    id: "line-mobile",
    tabLabel: "手机端线路",
    intro: "针对移动网络做过压缩优化，流量占用更低，适合在外使用。",
    lines: [
      { id: "mob-1", name: "手机主入口", region: "移动优化", status: "可用", statusKey: "ok", speed: "较快", note: "移动网络优先选择" },
      { id: "mob-2", name: "手机备用入口", region: "移动优化", status: "繁忙", statusKey: "busy", speed: "中等", note: "高峰时段可能排队" },
      { id: "mob-3", name: "流量节省入口", region: "移动优化", status: "可用", statusKey: "ok", speed: "中等", note: "低清晰度优先，节省流量" },
    ],
  },
  {
    id: "line-app",
    tabLabel: "APP 线路",
    intro: "需要先安装客户端，打开后可离线缓存、后台播放，体验更完整。",
    lines: [
      { id: "app-1", name: "APP 主线路", region: "客户端", status: "可用", statusKey: "ok", speed: "最快", note: "支持缓存与后台播放" },
      { id: "app-2", name: "APP 备用线路", region: "客户端", status: "可用", statusKey: "ok", speed: "较快", note: "更新后自动切换" },
      { id: "app-3", name: "APP 数据同步", region: "客户端", status: "维护中", statusKey: "maintain", speed: "—", note: "观看记录同步短暂维护" },
    ],
  },
];

export const statusLegend = [
  { key: "ok", label: "可用", desc: "可正常打开，推荐优先尝试" },
  { key: "busy", label: "繁忙", desc: "能打开但高峰时段较慢" },
  { key: "maintain", label: "维护中", desc: "该功能临时不可用，稍后再试" },
];

export const devices = [
  {
    id: "device-web",
    icon: "ri-computer-line",
    name: "网页端",
    tag: "免安装",
    best: "适合电脑大屏、长时间观看",
    rows: [
      { label: "是否需安装", value: "不需要" },
      { label: "占用空间", value: "几乎为零" },
      { label: "离线缓存", value: "不支持" },
      { label: "清晰度切换", value: "支持多档" },
      { label: "适合场景", value: "在家、办公间隙" },
    ],
  },
  {
    id: "device-mobile",
    icon: "ri-smartphone-line",
    name: "手机浏览器",
    tag: "最灵活",
    best: "适合临时打开、不想装应用",
    rows: [
      { label: "是否需安装", value: "不需要" },
      { label: "占用空间", value: "浏览器缓存" },
      { label: "离线缓存", value: "不支持" },
      { label: "清晰度切换", value: "支持多档" },
      { label: "适合场景", value: "通勤、外出零碎时间" },
    ],
  },
  {
    id: "device-app",
    icon: "ri-apps-2-line",
    name: "APP 客户端",
    tag: "功能最全",
    best: "适合常用、想要缓存与后台播放",
    rows: [
      { label: "是否需安装", value: "需要安装" },
      { label: "占用空间", value: "约几十到百余 MB" },
      { label: "离线缓存", value: "支持" },
      { label: "清晰度切换", value: "支持多档" },
      { label: "适合场景", value: "长期使用、移动观看" },
    ],
  },
];

export const genres = [
  {
    id: "genre-movie",
    name: "电影",
    icon: "ri-film-line",
    desc: "时长完整的院线或网络长片，剧情完整、节奏独立，适合一次看完。",
    highlight: "单次时长约 90–150 分钟",
  },
  {
    id: "genre-series",
    name: "剧集",
    icon: "ri-tv-2-line",
    desc: "多集连载内容，按季或按集更新，适合追更和连续多天观看。",
    highlight: "按集更新，可连播",
  },
  {
    id: "genre-variety",
    name: "综艺",
    icon: "ri-mic-2-line",
    desc: "真人秀、访谈、选秀等节目，节奏轻松，单集时长较短。",
    highlight: "单集约 40–90 分钟",
  },
  {
    id: "genre-anime",
    name: "动漫",
    icon: "ri-magic-line",
    desc: "动画剧集与动画电影，画风与题材差异大，常按季度集中更新。",
    highlight: "按季度集中更新",
  },
  {
    id: "genre-doc",
    name: "纪录片",
    icon: "ri-earth-line",
    desc: "自然、人文、历史等纪实内容，信息密度高，适合安静时观看。",
    highlight: "题材广泛，信息量大",
  },
];

export const titles = [
  {
    id: "t-1",
    name: "流浪地球",
    genre: "电影",
    genreId: "genre-movie",
    year: "2019",
    tags: ["科幻", "灾难", "国产"],
    poster: "https://readdy.ai/api/search-image?query=Stylized%20sci-fi%20cinematic%20poster%20art%20of%20a%20giant%20planet%20engine%20and%20frozen%20earth%2C%20warm%20amber%20and%20deep%20red%20glow%2C%20dramatic%20lighting%2C%20moody%20dark%20background%2C%20painterly%20illustration%2C%20no%20text&width=600&height=900&seq=shenma-poster-01&orientation=portrait",
    note: "硬科幻设定，适合喜欢宏大场面与工程想象的观众。",
  },
  {
    id: "t-2",
    name: "肖申克的救赎",
    genre: "电影",
    genreId: "genre-movie",
    year: "1994",
    tags: ["剧情", "经典", "人性"],
    poster: "https://readdy.ai/api/search-image?query=Stylized%20drama%20film%20poster%20art%20of%20a%20lone%20figure%20standing%20in%20rain%20under%20a%20warm%20streetlamp%2C%20orange%20glow%2C%20silhouette%2C%20cinematic%20moody%20dark%20background%2C%20painterly%20illustration%2C%20no%20text&width=600&height=900&seq=shenma-poster-02&orientation=portrait",
    note: "节奏沉稳的经典剧情片，适合想安静看一部好故事的晚上。",
  },
  {
    id: "t-3",
    name: "千与千寻",
    genre: "动漫",
    genreId: "genre-anime",
    year: "2001",
    tags: ["动画", "奇幻", "宫崎骏"],
    poster: "https://readdy.ai/api/search-image?query=Whimsical%20stylized%20animation%20poster%20art%20of%20a%20lantern-lit%20oriental%20street%20at%20night%2C%20warm%20amber%20lanterns%2C%20magical%20atmosphere%2C%20deep%20red%20accents%2C%20dark%20background%2C%20painterly%20illustration%2C%20no%20text&width=600&height=900&seq=shenma-poster-03&orientation=portrait",
    note: "奇幻动画代表作，画面与配乐都很有辨识度，适合全家一起看。",
  },
  {
    id: "t-4",
    name: "星际穿越",
    genre: "电影",
    genreId: "genre-movie",
    year: "2014",
    tags: ["科幻", "太空", "亲情"],
    poster: "https://readdy.ai/api/search-image?query=Stylized%20space%20film%20poster%20art%20of%20a%20vast%20ringed%20planet%20and%20a%20tiny%20spacecraft%2C%20warm%20golden%20nebula%2C%20deep%20space%2C%20cinematic%20moody%20background%2C%20painterly%20illustration%2C%20no%20text&width=600&height=900&seq=shenma-poster-04&orientation=portrait",
    note: "兼顾科学与情感的科幻片，画面适合在较大屏幕上观看。",
  },
  {
    id: "t-5",
    name: "让子弹飞",
    genre: "电影",
    genreId: "genre-movie",
    year: "2010",
    tags: ["喜剧", "动作", "国产"],
    poster: "https://readdy.ai/api/search-image?query=Stylized%20western%20poster%20art%20of%20a%20lone%20rider%20silhouette%20on%20a%20dusty%20plain%20at%20sunset%2C%20warm%20orange%20sky%2C%20dramatic%20light%2C%20painterly%20illustration%2C%20no%20text&width=600&height=900&seq=shenma-poster-05&orientation=portrait",
    note: "台词密度高的国产喜剧，节奏明快，适合朋友一起看。",
  },
  {
    id: "t-6",
    name: "霸王别姬",
    genre: "电影",
    genreId: "genre-movie",
    year: "1993",
    tags: ["剧情", "经典", "京剧"],
    poster: "https://readdy.ai/api/search-image?query=Stylized%20classic%20opera%20drama%20poster%20art%20of%20a%20Peking%20opera%20performer%20in%20ornate%20costume%2C%20red%20and%20gold%20tones%2C%20dramatic%20stage%20light%2C%20dark%20background%2C%20painterly%20illustration%2C%20no%20text&width=600&height=900&seq=shenma-poster-06&orientation=portrait",
    note: "跨越数十年的经典剧情片，表演与叙事都值得反复回味。",
  },
  {
    id: "t-7",
    name: "三体",
    genre: "剧集",
    genreId: "genre-series",
    year: "2023",
    tags: ["科幻", "剧集", "国产"],
    poster: "https://readdy.ai/api/search-image?query=Stylized%20sci-fi%20series%20poster%20art%20of%20a%20giant%20radio%20telescope%20under%20a%20deep%20red%20sky%2C%20dusty%20atmosphere%2C%20dramatic%20light%2C%20dark%20background%2C%20painterly%20illustration%2C%20no%20text&width=600&height=900&seq=shenma-poster-07&orientation=portrait",
    note: "改编自同名小说的科幻剧集，适合按集追看、慢慢展开设定。",
  },
  {
    id: "t-8",
    name: "蓝色星球",
    genre: "纪录片",
    genreId: "genre-doc",
    year: "2001",
    tags: ["自然", "纪实", "海洋"],
    poster: "https://readdy.ai/api/search-image?query=Stylized%20nature%20documentary%20poster%20art%20of%20deep%20ocean%20with%20warm%20sunlight%20rays%20and%20soft%20teal%20water%2C%20cinematic%20dark%20background%2C%20painterly%20illustration%2C%20no%20text&width=600&height=900&seq=shenma-poster-08&orientation=portrait",
    note: "海洋题材自然纪录片，画面安静，适合放松时观看。",
  },
];

export const faqs = [
  {
    id: "faq-1",
    q: "打开页面一直转圈或提示无法访问，怎么处理？",
    a: "先确认网络本身正常，再回到本页的线路状态区，按「网页端线路」的顺序换一条重新打开。如果多条都打不开，通常是本地网络或浏览器缓存的问题，可以尝试切换网络、清理缓存或换一个浏览器再试。",
  },
  {
    id: "faq-2",
    q: "网页端和 APP 应该选哪个？",
    a: "只是想快速看一次、不想安装任何东西，用网页端最省事；如果经常观看、希望有离线缓存和后台播放，再考虑安装 APP 客户端。可以先在网页端确认内容符合预期，再决定是否安装。",
  },
  {
    id: "faq-3",
    q: "为什么有的线路显示「繁忙」或「维护中」？",
    a: "观看高峰时段部分线路并发较高，会显示为繁忙；维护中的线路通常是该功能在做临时调整，稍后刷新即可。这两种状态并不代表站点不可用，换用标注为「可用」的线路即可。",
  },
  {
    id: "faq-4",
    q: "在手机上观看需要注意什么？",
    a: "移动网络下建议优先选择标注为移动优化的线路，并在清晰度上选择较低档位以节省流量。观看时间较长时注意设备发热，外出时提前确认剩余流量是否充足。",
  },
  {
    id: "faq-5",
    q: "地址会经常变化吗？怎样第一时间知道？",
    a: "入口地址可能因网络环境变化而调整，本站会尽量同步维护线路说明。建议把本页加入浏览器收藏，需要时回到这里按当前状态选择合适的线路，而不是依赖某一条固定地址。",
  },
  {
    id: "faq-6",
    q: "搜索和筛选是怎么工作的？",
    a: "本页的搜索与类型筛选只作用于当前页面已经列出的片单，不会向任何服务器发起请求。输入关键词或选择类型标签后，下方列表会即时更新，清空条件即可恢复完整列表。",
  },
];

export const safetyTips = [
  {
    id: "safe-1",
    icon: "ri-shield-check-line",
    title: "认准本页给出的入口",
    desc: "优先使用本页列出的线路，不要点击聊天群、短信或陌生弹窗里转发的短链，这类链接最容易指向仿冒页面。",
  },
  {
    id: "safe-2",
    icon: "ri-error-warning-line",
    title: "警惕任何付费与充值要求",
    desc: "观影类导航站不会要求你付费开通会员或填写支付信息。凡是要求充值、扫码付款、输入银行卡的页面都应直接关闭。",
  },
  {
    id: "safe-3",
    icon: "ri-lock-password-line",
    title: "不提交账号与验证码",
    desc: "不要在任何页面填写手机验证码、社交账号密码或身份证信息。正规的观看入口不会索要这些内容。",
  },
  {
    id: "safe-4",
    icon: "ri-download-2-line",
    title: "安装包只从说明页面获取",
    desc: "如需安装 APP，请确认安装包来源与说明一致，安装前查看系统提示的权限列表，对索取通讯录、短信权限的应用保持警惕。",
  },
];

export const updates = [
  { id: "u-1", date: "2026-09-28", title: "线路状态说明细化", desc: "补充了「可用 / 繁忙 / 维护中」三种状态的判断标准与处理建议。" },
  { id: "u-2", date: "2026-09-12", title: "新增多端对比", desc: "整理网页端、手机浏览器与 APP 客户端在缓存、清晰度上的差异。" },
  { id: "u-3", date: "2026-08-30", title: "片单速览上线", desc: "新增可按类型筛选、可关键词搜索的片单模块，方便快速定位想看的题材。" },
  { id: "u-4", date: "2026-08-15", title: "安全提示整合", desc: "汇总常见仿冒页面特征，提醒用户避免在非官方入口提交任何信息。" },
];

export const navItems = [
  { id: "nav-entry", label: "快速入口", href: "#entry" },
  { id: "nav-lines", label: "线路状态", href: "#lines" },
  { id: "nav-devices", label: "多端对比", href: "#devices" },
  { id: "nav-genres", label: "内容类型", href: "#genres" },
  { id: "nav-titles", label: "片单速览", href: "#titles" },
  { id: "nav-faq", label: "常见问题", href: "#faq" },
  { id: "nav-safety", label: "安全提示", href: "#safety" },
];